import { useCallback, useMemo } from 'react';
import { getForceSignOutValue } from '../redux/forceLogOut';
import { useHRMSUser } from './useSelector';
import { useAppDispatch } from '../redux/reduxhooks';

export const useConditionalEffects = () => {
    const dispatch = useAppDispatch();
    const hasHRMSUser = useHRMSUser();

    const runEffects = useCallback(async () => {
        if (!hasHRMSUser) {
            dispatch(getForceSignOutValue());
        }
    }, [dispatch, hasHRMSUser]);

    const memoizedRunEffects = useMemo(() => runEffects, [runEffects]);

    const debounce = <T extends (...args: any[]) => any>(func: T, delay: number) => {
        let timeoutId: ReturnType<typeof setTimeout>;
        return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
            const context = this;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    };

    const debouncedRunEffects = useMemo(() => debounce(memoizedRunEffects, 300), [memoizedRunEffects]);

    return debouncedRunEffects;
};
